<template>
  <div>
    <template v-for="(filter, index) in filters">
      <b-tag v-if="filter.filterLabel" @remove="$emit('remove', index)" :key="index" class="mr-2" variant="secondary">{{ filter.filterLabel }}</b-tag>
    </template>
  </div>
</template>

<script>
  export default {
    name: "filters"   ,
    props : [ 'filters' ]
  }
</script>

<style lang="scss" scoped>

</style>